const highlightProducts2025 = [
  {
    id: 78696,
    nr: "7680523",
    title: "Bloody Mary",
    slug: "bloody-mary",
    copy:
      "Begrüß das neue Jahr mit einem goldenen Kometenschauer! Herrliche Verwandlungs-Stern-Buketts  sorgen für besondere Highlights und lassen euch aus dem Staunen gar nicht mehr herauskommen.",
    image:
      "https://feuerwerk.rewe.de/backend/assets/products/7680523-Bloody-Marry-3363.png",
    thumb:
      "https://feuerwerk.rewe.de/backend/assets/products/_productpicOverview/7680523-Bloody-Marry-3363.png",
    background: null,
    backgroundThumb: null,
    previewGif: null,
    portrait: false,
    youtubeId: null,
    price: 0,
    priceApp: 0,
    teile: 0,
    teileUeber: false,
    schuss: 12,
    kaliber: 20,
    effekthoehe: 40,
    laenge: 25,
    zeigeAttribut: "schuss",
    sortierungHoch: false,
    tvSpot: false,
    categories: ["Batteriefeuerwerk"],
  },
  {
    id: 78708,
    nr: "8292455",
    title: "Dicke Brummer XXL",
    slug: "dicker-brummer-xxl",
    copy:
      "Für noch mehr Wirbel: die extragroße Variante der kultige Bodenkreisel. Feier das neue Jahr mit einem satten Brummen!",
    image:
      "https://feuerwerk.rewe.de/backend/assets/products/8292455_Dicker-Brummer-XXL_4917.png",
    thumb:
      "https://feuerwerk.rewe.de/backend/assets/products/_productpicOverview/8292455_Dicker-Brummer-XXL_4917.png",
    background:
      "https://feuerwerk.rewe.de/backend/assets/productsbackgrounds/8292455_Dicker-Brummer-XXL_4917_Effekt-01.jpg",
    backgroundThumb:
      "https://feuerwerk.rewe.de/backend/assets/productsbackgrounds/_productpicOverview/8292455_Dicker-Brummer-XXL_4917_Effekt-01.jpg",
    previewGif: null,
    portrait: false,
    youtubeId: null,
    price: 0,
    priceApp: 0,
    teile: 8,
    teileUeber: false,
    schuss: 0,
    kaliber: 0,
    effekthoehe: 0,
    laenge: 0,
    zeigeAttribut: "null",
    sortierungHoch: false,
    tvSpot: false,
    categories: ["Jugendfeuerwerk"],
  },
  {
    id: 78710,
    nr: "8936517",
    title: "Elements of Fire",
    slug: "elements-of-fire",
    copy:
      "Das große Leuchten: Mit diesem vielfältigen Raketen-Set startest du perfekt gerüstet ins neue Jahr. Lass' den Himmel erstrahlen!",
    image:
      "https://feuerwerk.rewe.de/backend/assets/products/8936517-Elements-of-Fire-203810.png",
    thumb:
      "https://feuerwerk.rewe.de/backend/assets/products/_productpicOverview/8936517-Elements-of-Fire-203810.png",
    background: null,
    backgroundThumb: null,
    previewGif: null,
    portrait: true,
    youtubeId: null,
    price: 0,
    priceApp: 0,
    teile: 14,
    teileUeber: false,
    schuss: 0,
    kaliber: 0,
    effekthoehe: 0,
    laenge: 0,
    zeigeAttribut: "null",
    sortierungHoch: false,
    tvSpot: false,
    categories: ["Raketensortiment"],
  },
  {
    id: 78720,
    nr: "7678729",
    title: "Gloria Raketensortiment",
    slug: "gloria-raketensortiment",
    copy:
      "Himmlisch abwechslungsreich! Mit diesem Raketensortiment bringst du den Himmel in allen Farben zum Leuchten. Bereit, dich ins neue Jahr katapultieren zu lassen?",
    image:
      "https://feuerwerk.rewe.de/backend/assets/products/7678729-GLORIA-_1_-294040-115.png",
    thumb:
      "https://feuerwerk.rewe.de/backend/assets/products/_productpicOverview/7678729-GLORIA-_1_-294040-115.png",
    background: null,
    backgroundThumb: null,
    previewGif: null,
    portrait: true,
    youtubeId: null,
    price: 0,
    priceApp: 0,
    teile: 6,
    teileUeber: false,
    schuss: 0,
    kaliber: 0,
    effekthoehe: 0,
    laenge: 0,
    zeigeAttribut: "null",
    sortierungHoch: false,
    tvSpot: false,
    categories: ["Raketensortiment"],
  },
  {
    id: 78722,
    nr: "7680623",
    title: "Golden Spirit",
    slug: "golden-spirit",
    copy:
      "Einfach raketenstark: Diese edlen Feuerwerksraketen imponieren mit verschiedenartigen Gold-Effekten – und einem Knall, der sich hören lassen kann!",
    image:
      "https://feuerwerk.rewe.de/backend/assets/products/7680623-Golden-Spirit-203050.png",
    thumb:
      "https://feuerwerk.rewe.de/backend/assets/products/_productpicOverview/7680623-Golden-Spirit-203050.png",
    background: null,
    backgroundThumb: null,
    previewGif:
      "https://feuerwerk.rewe.de/backend/assets/productsvideogifs/Golden-Spirit_203010-115.gif",
    portrait: true,
    youtubeId: "FUgZ9DId0o0",
    price: 0,
    priceApp: 0,
    teile: 10,
    teileUeber: false,
    schuss: 0,
    kaliber: 0,
    effekthoehe: 0,
    laenge: 0,
    zeigeAttribut: "null",
    sortierungHoch: false,
    tvSpot: false,
    categories: ["Raketensortiment"],
  },
  {
    id: 78732,
    nr: "2271491",
    title: "Kids Party",
    slug: "kids-party",
    copy:
      "Was für ein Bombenspaß! Dieses Tischfeuerwerk mit bunter Füllung ist ein echter Party-Höhepunkt mit Knall-Effekt – gute Laune inklusive.",
    image:
      "https://feuerwerk.rewe.de/backend/assets/products/NAN_2271491_Kids_Party_Hochkant_Format_591510-45-removebg.png",
    thumb:
      "https://feuerwerk.rewe.de/backend/assets/products/_productpicOverview/NAN_2271491_Kids_Party_Hochkant_Format_591510-45-removebg.png",
    background: null,
    backgroundThumb: null,
    previewGif: null,
    portrait: false,
    youtubeId: null,
    price: 0,
    priceApp: 0,
    teile: 4,
    teileUeber: false,
    schuss: 0,
    kaliber: 0,
    effekthoehe: 0,
    laenge: 0,
    zeigeAttribut: "null",
    sortierungHoch: false,
    tvSpot: false,
    categories: ["Jugendfeuerwerk"],
  },
  {
    id: 78734,
    nr: "2271459",
    title: "Knallbonbons",
    slug: "knallbonbons",
    copy:
      "Überraschungen, die knallen! Einfach das große Bonbon an beiden Enden auseinanderziehen und auf das kleine Geschenk darin gespannt sein …",
    image:
      "https://feuerwerk.rewe.de/backend/assets/products/2271459-Knallbonbons-0960-45.png",
    thumb:
      "https://feuerwerk.rewe.de/backend/assets/products/_productpicOverview/2271459-Knallbonbons-0960-45.png",
    background: null,
    backgroundThumb: null,
    previewGif: null,
    portrait: false,
    youtubeId: null,
    price: 0,
    priceApp: 0,
    teile: 4,
    teileUeber: false,
    schuss: 0,
    kaliber: 0,
    effekthoehe: 0,
    laenge: 0,
    zeigeAttribut: "null",
    sortierungHoch: false,
    tvSpot: false,
    categories: ["Jugendfeuerwerk"],
  },
  {
    id: 78754,
    nr: "6533051",
    title: "Pina Colada",
    slug: "pina-colada",
    copy:
      "Rote Bengal-Basis mit prächtiger Silberfontäne, wechselnd auf gelbe Bengal-Basis mit soundstarken Crackling-Sternen und bunten Leucht-Effekten sowie erneute Verwandlung auf Rot-Silber; jeweils angekündigt durch eine schrille Silberpfeife. Oder kurz gesagt: Wir wünschen dir ein frohes buntes Jahr!",
    image:
      "https://feuerwerk.rewe.de/backend/assets/products/6533051-Pina-Colada-3424-45_2023.png",
    thumb:
      "https://feuerwerk.rewe.de/backend/assets/products/_productpicOverview/6533051-Pina-Colada-3424-45_2023.png",
    background:
      "https://feuerwerk.rewe.de/backend/assets/productsbackgrounds/6533051_Pina-Colada_3424-45_Effekt-01.jpg",
    backgroundThumb:
      "https://feuerwerk.rewe.de/backend/assets/productsbackgrounds/_productpicOverview/6533051_Pina-Colada_3424-45_Effekt-01.jpg",
    previewGif:
      "https://feuerwerk.rewe.de/backend/assets/productsvideogifs/Pina-Colada_3424-45.gif",
    portrait: true,
    youtubeId: "k5MKjbZP_8c",
    price: 0,
    priceApp: 0,
    teile: 0,
    teileUeber: false,
    schuss: 0,
    kaliber: 0,
    effekthoehe: 0,
    laenge: 60,
    zeigeAttribut: "laenge",
    sortierungHoch: false,
    tvSpot: false,
    categories: ["Leuchtsortiment"],
  },
  {
    id: 78770,
    nr: "8006867",
    title: "Starlight",
    slug: "starlight",
    copy:
      "Der Star jeden Feuerwerks:  \nEinmal anzünden genügt und schon begeistert diese imposante 64-Schuss-Batterie mit Blinkstern-Buketts in Rot, Blau und Weiß. Das Finale: eine besonders effektvolle Salve – einfach sensationell!",
    image:
      "https://feuerwerk.rewe.de/backend/assets/products/8006867_Starlight_3184-115.png",
    thumb:
      "https://feuerwerk.rewe.de/backend/assets/products/_productpicOverview/8006867_Starlight_3184-115.png",
    background:
      "https://feuerwerk.rewe.de/backend/assets/productsbackgrounds/8006867_Starlight_3184-115_Effekt-02.jpg",
    backgroundThumb:
      "https://feuerwerk.rewe.de/backend/assets/productsbackgrounds/_productpicOverview/8006867_Starlight_3184-115_Effekt-02.jpg",
    previewGif:
      "https://feuerwerk.rewe.de/backend/assets/productsvideogifs/Starlight_3184-115.gif",
    portrait: false,
    youtubeId: "cxYJzs7UO2E",
    price: 0,
    priceApp: 0,
    teile: 0,
    teileUeber: false,
    schuss: 64,
    kaliber: 14,
    effekthoehe: 35,
    laenge: 30,
    zeigeAttribut: "schuss",
    sortierungHoch: false,
    tvSpot: false,
    categories: ["Batteriefeuerwerk"],
  },
];

const highlightProducts2026 = [
  {
    id: 87764,
    nr: "9853463",
    title: "Crackling Chaos",
    slug: "crackling-chaos",
    copy:
      "Wild, laut, unberechenbar – Crackling Chaos sorgt für maximale Action! Sechs kräftige Effektkörper zünden einen intensiven Knatterregen, der den Boden erbeben lässt. Der intensive Crackling-Effekt verwandelt jede Silvesternacht in ein funkelndes Spektakel voller Energie.",
    image:
      "https://feuerwerk.rewe.de/backend/assets/products/Crackling-Chaos-50632719-min.png",
    thumb:
      "https://feuerwerk.rewe.de/backend/assets/products/_productpicOverview/Crackling-Chaos-50632719-min.png",
    background: null,
    backgroundThumb: null,
    previewGif: null,
    portrait: false,
    youtubeId: "DbXNtn0Dtvs",
    price: 3.99,
    priceApp: 0,
    teile: 6,
    teileUeber: false,
    schuss: 0,
    kaliber: 0,
    effekthoehe: 0,
    laenge: 0,
    zeigeAttribut: "null",
    sortierungHoch: false,
    tvSpot: false,
    categories: ["Knallsortiment"],
  },
  {
    id: 87756,
    nr: "9856074",
    title: "Anubis",
    slug: "anubis",
    copy:
      "Mystisch, farbenprächtig, faszinierend: Anubis entzündet eine 50 Sekunden lange Fontänen-Show voller Abwechslung. Bunte Leuchtsterne steigen auf und wechseln sich mit silbernen Blinksternen ab – ein dynamisches Spiel aus Licht und Bewegung. Im harmonischen Wechsel entfalten sich kraftvolle Fontänen, die in einem funkelnden Finale gipfeln. Für alle, die Feuerwerk als Ritual zelebrieren!",
    image:
      "https://feuerwerk.rewe.de/backend/assets/products/Anubis-50632947-min.png",
    thumb:
      "https://feuerwerk.rewe.de/backend/assets/products/_productpicOverview/Anubis-50632947-min.png",
    background: null,
    backgroundThumb: null,
    previewGif: null,
    portrait: true,
    youtubeId: "N4zGVZpdHEI",
    price: 5.99,
    priceApp: 0,
    teile: 1,
    teileUeber: false,
    schuss: 0,
    kaliber: 18,
    effekthoehe: 4,
    laenge: 50,
    zeigeAttribut: "null",
    sortierungHoch: false,
    tvSpot: false,
    categories: ["Leuchtsortiment"],
  },
  {
    id: 87782,
    nr: "9837441",
    title: "Merlin",
    slug: "merlin",
    copy:
      "Ein magisches Feuerwerk für die ganze Familie: Das Jugendfeuerwerk-Sortiment Merlin bietet über 170 Einzelteile mit funkelnden, knatternden und blitzenden Effekten. Von Sternspritzern und Mini-Vulkanen bis zu Knatterteufeln und Wunderkerzen – hier steckt alles drin, was kleine Zauberer begeistert. Ideal für leuchtende Augen und sichere Pyro-Abenteuer!",
    image:
      "https://feuerwerk.rewe.de/backend/assets/products/Merlin-50798719-min.png",
    thumb:
      "https://feuerwerk.rewe.de/backend/assets/products/_productpicOverview/Merlin-50798719-min.png",
    background: null,
    backgroundThumb: null,
    previewGif: null,
    portrait: false,
    youtubeId: null,
    price: 7.99,
    priceApp: 0,
    teile: 174,
    teileUeber: false,
    schuss: 0,
    kaliber: 0,
    effekthoehe: 0,
    laenge: 0,
    zeigeAttribut: "null",
    sortierungHoch: false,
    tvSpot: false,
    categories: ["Jugendfeuerwerk"],
  },
  {
    id: 78764,
    nr: "8937938",
    title: "Spectrum",
    slug: "spectrum",
    copy:
      "Alles für die Nacht der Farben: Dieser abwechslungsreiche Raketen-Mix beeindruckt mit prächtigen Mutli-Colour-Effekten, smaragdgrünen sowie brillantroten Leucht-Buketts und aufregenden Silberflimmer-Wolken. Teilweise mit fetzigem Knall-Effekt – so klingt Silvester!",
    image:
      "https://feuerwerk.rewe.de/backend/assets/products/Spectrum-41424813_2025-11-27-163323_nmxm.png",
    thumb:
      "https://feuerwerk.rewe.de/backend/assets/products/_productpicOverview/Spectrum-41424813_2025-11-27-163323_nmxm.png",
    background: null,
    backgroundThumb: null,
    previewGif: null,
    portrait: true,
    youtubeId: null,
    price: 11.99,
    priceApp: 0,
    teile: 10,
    teileUeber: false,
    schuss: 10,
    kaliber: 0,
    effekthoehe: 0,
    laenge: 0,
    zeigeAttribut: "null",
    sortierungHoch: false,
    tvSpot: false,
    categories: ["Raketensortiment"],
  },
  {
    id: 87758,
    nr: "9854171",
    title: "Aviator",
    slug: "aviator",
    copy:
      "Abheben und Staunen: Der Aviator bringt 46 kraftvolle Schuss mit bis zu 14 mm Kaliber in den Nachthimmel. In 30 Sekunden entfaltet sich ein dynamisches Spiel aus roten und grünen Leuchtsternen mit passenden Aufstiegen – teils begleitet von funkelndem Crackling. Eine Multi-Effekt-Batterie, die Eleganz und Energie zu einem eindrucksvollen Flugmanöver verbindet.",
    image:
      "https://feuerwerk.rewe.de/backend/assets/products/Aviator-50798720-min.png",
    thumb:
      "https://feuerwerk.rewe.de/backend/assets/products/_productpicOverview/Aviator-50798720-min.png",
    background: null,
    backgroundThumb: null,
    previewGif: null,
    portrait: false,
    youtubeId: "mERcKonLQOQ",
    price: 12.99,
    priceApp: 0,
    teile: 1,
    teileUeber: false,
    schuss: 46,
    kaliber: 14,
    effekthoehe: 30,
    laenge: 30,
    zeigeAttribut: "null",
    sortierungHoch: false,
    tvSpot: false,
    categories: ["Batteriefeuerwerk"],
  },
  {
    id: 82710,
    nr: "9081113",
    title: "Fire Destination",
    slug: "fire-destination",
    copy:
      "Mit über 45 Einzelteilen rasen alle Partygäste mit Vollgas ins neue Jahr: 8 Brillant-Effekt-Raketen mit coolen Silberflimmer-Wolken und großen Brokat-Buketts, dazu Römische Lichter, Feuervögel und lautstarke Böller. Leute, die Nacht wird lang!",
    image:
      "https://feuerwerk.rewe.de/backend/assets/products/Fire-Destination-45579540_2025-11-27-163024_vsbp.png",
    thumb:
      "https://feuerwerk.rewe.de/backend/assets/products/_productpicOverview/Fire-Destination-45579540_2025-11-27-163024_vsbp.png",
    background: null,
    backgroundThumb: null,
    previewGif: null,
    portrait: true,
    youtubeId: null,
    price: 19.99,
    priceApp: 0,
    teile: 45,
    teileUeber: true,
    schuss: 43,
    kaliber: 0,
    effekthoehe: 0,
    laenge: 0,
    zeigeAttribut: "null",
    sortierungHoch: false,
    tvSpot: false,
    categories: ["Familiensortiment"],
  },
  {
    id: 82705,
    nr: "9085575",
    title: "Commander",
    slug: "commander",
    copy:
      "Ready for the time warp? Commander katapultiert euch mit einem imposanten Feuerwerk ins neue Jahr. 148 Effekte schießen mit bis zu 20-mm-Kalibern ins Universum: rote, violette und blaue Buketts mit Blinksternen und Gold-Glitter, herrliche Verwandlungssterne bis hin zu leuchtintensiven Chrysanthemen- und Palmenmotiven.",
    image:
      "https://feuerwerk.rewe.de/backend/assets/products/Commander-45579630.png",
    thumb:
      "https://feuerwerk.rewe.de/backend/assets/products/_productpicOverview/Commander-45579630.png",
    background: null,
    backgroundThumb: null,
    previewGif: null,
    portrait: false,
    youtubeId: null,
    price: 26.99,
    priceApp: 0,
    teile: 0,
    teileUeber: false,
    schuss: 148,
    kaliber: 20,
    effekthoehe: 50,
    laenge: 60,
    zeigeAttribut: "null",
    sortierungHoch: false,
    tvSpot: false,
    categories: ["Systemfeuerwerk"],
  },
  {
    id: 78738,
    nr: "7988960",
    title: "Lord of Lights XXL",
    slug: "lord-of-lights-xxl",
    copy:
      "Mehr Leuchten geht wirklich nicht! In diesem Batterie-Sortiment stecken 421 Schuss pure Lichtexplosion: Große Sternbuketts, bunte Leuchtkometen und Römische Lichter bringen das neue Jahr zum Strahlen!",
    image:
      "https://feuerwerk.rewe.de/backend/assets/products/Lord-of-Lights-XXL-7988960.png",
    thumb:
      "https://feuerwerk.rewe.de/backend/assets/products/_productpicOverview/Lord-of-Lights-XXL-7988960.png",
    background:
      "https://feuerwerk.rewe.de/backend/assets/productsbackgrounds/7988960_Lord-of-Lights-XXL_397480_Effekt-03.jpg",
    backgroundThumb:
      "https://feuerwerk.rewe.de/backend/assets/productsbackgrounds/_productpicOverview/7988960_Lord-of-Lights-XXL_397480_Effekt-03.jpg",
    previewGif: null,
    portrait: false,
    youtubeId: null,
    price: 39.99,
    priceApp: 0,
    teile: 10,
    teileUeber: false,
    schuss: 421,
    kaliber: 0,
    effekthoehe: 0,
    laenge: 0,
    zeigeAttribut: "schuss",
    sortierungHoch: false,
    tvSpot: false,
    categories: ["Batteriefeuerwerk"],
  },
  {
    id: 87797,
    nr: "7586476",
    title: "Unleash the Kaiju",
    slug: "unleash-the-kaiju-bonus-artikel-mit-25-bonus-guthaben",
    copy:
      "Erwecke das Biest: Unleash the Kaiju entfesselt in 45 Sekunden ein gewaltiges Feuerwerk aus 150 Schuss purer Energie. Goldene Brokatkronen, farbintensive Blinksterne und donnernde Knattereffekte steigen bis zu 40 Meter hoch in den Nachthimmel. Drei perfekt aufeinander abgestimmte Batterien erzeugen eine imposante Show – laut, kraftvoll und spektakulär wie ein Filmmonster.",
    image:
      "https://feuerwerk.rewe.de/backend/assets/products/Unleash-the-Kaiju-50631343-min.png",
    thumb:
      "https://feuerwerk.rewe.de/backend/assets/products/_productpicOverview/Unleash-the-Kaiju-50631343-min.png",
    background: null,
    backgroundThumb: null,
    previewGif: null,
    portrait: true,
    youtubeId: "6rRusDUgoXY",
    price: 79.99,
    priceApp: 0,
    teile: 1,
    teileUeber: false,
    schuss: 150,
    kaliber: 20,
    effekthoehe: 40,
    laenge: 45,
    zeigeAttribut: "null",
    sortierungHoch: false,
    tvSpot: false,
    categories: ["Systemfeuerwerk"],
  },
];

const highlightProducts = highlightProducts2025;

export default highlightProducts;
